import React, { useEffect, useState } from "react";
import {
  FormInputAdjusmentStock,
  RESET_STATE_ADJUSMENT_STOCK,
  getAllBarangByGudang,
  getAllBarangByAdjusment,
  RenderSimpanButton,
  DaftarBarang,
  ItemTransfer,
} from "./ui";
import { STYLE_MASTER_GUDANG_UTAMA } from "App/Component/layout/Wms/MasterWms/MasterGudangUtama/ui";
import { Title } from "App/Component/ui";
import { RESET_STATE_FORM_FILTER } from "../DaftarInventoryControl/helpers";
import { defaultToastError, isNull } from "App/utils/helpers";
import { Grid } from "@material-ui/core";
import { WMS_LGS_INPUT_ADJUST } from "App/constants";

function InputAdjusmentStock({ menu, data }) {
  const classes = STYLE_MASTER_GUDANG_UTAMA();
  const [formData, setFormData] = useState(() => {
    if (isNull(menu)) {
      return RESET_STATE_ADJUSMENT_STOCK;
    } else {
      if (menu === WMS_LGS_INPUT_ADJUST) {
        return data;
      } else {
        return RESET_STATE_ADJUSMENT_STOCK;
      }
    }
  });

  const [rowsBarangByGudang, setRowsBarangByGudang] = useState([]);
  const [rowsBarangByAdjusment, setRowsBarangByAdjusment] = useState([]);

  const [formFilterBarangByGudang, setFormFilterBarangByGudang] = useState(
    RESET_STATE_FORM_FILTER
  );

  const [formFilterBarangByAdjusment, setFormFilterBarangByAdjusment] =
    useState(RESET_STATE_FORM_FILTER);

  const [totalDataBarangByGudang, setTotalDataBarangByGudang] = useState(0);
  const [loadingBarangByGudang, setLoadingBarangByGudang] = useState(false);

  const [totalDataBarangByAdjusment, setTotalDataBarangByAdjusment] =
    useState(0);
  const [loadingBarangByAdjusment, setLoadingBarangByAdjusment] =
    useState(false);

  const setNewDataBarangByGudang = async (
    pages = formFilterBarangByGudang.pages,
    limit = formFilterBarangByGudang.limit
  ) => {
    if (!isNull(formData.gudang_id)) {
      setLoadingBarangByGudang(true);
      const res = await getAllBarangByGudang(
        formData,
        formFilterBarangByGudang,
        pages,
        limit
      );

      if (res.state) {
        setRowsBarangByGudang(res.data);
        setTotalDataBarangByGudang(res.meta.count);
        setLoadingBarangByGudang(false);
      } else {
        setRowsBarangByGudang([]);
        setLoadingBarangByGudang(false);
        defaultToastError(res.message);
      }
    }
  };

  const setNewDataBarangByAdjusment = async (
    pages = formFilterBarangByAdjusment.pages,
    limit = formFilterBarangByAdjusment.limit
  ) => {
    if (!isNull(formData.id)) {
      setLoadingBarangByAdjusment(true);
      const res = await getAllBarangByAdjusment(
        formData,
        formFilterBarangByAdjusment,
        pages,
        limit
      );

      if (res.state) {
        setRowsBarangByAdjusment(res.data);
        setTotalDataBarangByAdjusment(res.meta.count);
        setLoadingBarangByAdjusment(false);
      } else {
        setRowsBarangByAdjusment([]);
        setLoadingBarangByAdjusment(false);
        defaultToastError(res.message);
      }
    }
  };

  useEffect(() => {
    (async () => {
      await setNewAllData();
    })();
  }, [formData.id]); // eslint-disable-line react-hooks/exhaustive-deps

  async function setNewAllData() {
    await setNewDataBarangByGudang();
    await setNewDataBarangByAdjusment();
  }

  useEffect(() => {
    if (!isNull(menu) && menu === WMS_LGS_INPUT_ADJUST) {
      setFormData(data);
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   if (isNull(menu)) {
  //     setFormData(RESET_STATE_ADJUSMENT_STOCK);
  //   } else {
  //     if (menu === WMS_LGS_INPUT_ADJUST) {
  //       setFormData(data);
  //     } else {
  //       setFormData(RESET_STATE_ADJUSMENT_STOCK);
  //     }
  //   }
  // }, []);

  return (
    <div className={classes.root}>
      <Title title='Input Adjusment Stock Logistik' />
      <FormInputAdjusmentStock formData={formData} setFormData={setFormData} />

      {!isNull(formData.id) && (
        <div
          style={{
            padding: "1rem 0rem",
          }}>
          <Grid container spacing={3}>
            <Grid item sm={6}>
              <DaftarBarang
                formData={formData}
                setNewDataBarangByAdjusment={setNewDataBarangByAdjusment}
                setNewDataBarangByGudang={setNewDataBarangByGudang}
                totalData={totalDataBarangByGudang}
                loading={loadingBarangByGudang}
                rows={rowsBarangByGudang}
                setFormFilterBarangByGudang={setFormFilterBarangByGudang}
                formFilterBarangByGudang={formFilterBarangByGudang}
                setNewAllData={setNewAllData}
              />
            </Grid>
            <Grid item sm={6}>
              <ItemTransfer
                formData={formData}
                setNewDataBarangByAdjusment={setNewDataBarangByAdjusment}
                totalData={totalDataBarangByAdjusment}
                loading={loadingBarangByAdjusment}
                rows={rowsBarangByAdjusment}
                setFormFilterBarangByAdjusment={setFormFilterBarangByAdjusment}
                formFilterBarangByAdjusment={formFilterBarangByAdjusment}
              />
            </Grid>
          </Grid>
        </div>
      )}
      <RenderSimpanButton
        formData={formData}
        setFormData={setFormData}
        setNewAllData={setNewAllData}
      />
    </div>
  );
}

export default InputAdjusmentStock;
